export default __webpack_public_path__ + "static/media/icon_compare.5997a361.svg";